
import {getToken, setToken, setUserInfo, getUserInfo,setLocalPublicKey} from '@/utils/auth'
import Vuex from 'vuex'
import Vue from 'vue'
import httpRequest from '@/server/http-api'
import $ from 'jquery'
Vue.use(Vuex)

const state = {
  user: getUserInfo(),
  token: getToken(),
  loginStatus: !!getToken(),
  chatMessage: null,
  webImErrorCode: '',
  skus: false,
  localPublicKey: null,
  goodsIds: [],
  loginPopShowStatus: false,
  startup: null
}

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data.token
    setToken(data.token)
  },
  GET_USER: (state, data) => {
    state.user = data
    setUserInfo(data)
  },
  LOGIN: (state, data) => {
    state.loginStatus = data
  },
  LOGOUT: (state) => {
    state.token = false
    state.user = false
    state.loginStatus = false
    setToken(false)
    setUserInfo(false)
  },
  updateMessageMid: (state) => {
    
  },
  SET_CHATMESSAGE: function(state,data) {
    var afterObj = {};
    var obj = data;

    if (obj) {
      for(var key in obj) {
        if (obj.hasOwnProperty(key)) {
          afterObj[key] = obj[key];
  
          if (afterObj[key] && typeof(afterObj[key]) == 'object') {
            for (var childKey in afterObj[key]) {
              if (afterObj[key].hasOwnProperty(childKey)) {
                var childOjb = afterObj[key][childKey];
  
                if (childOjb.hasOwnProperty('low')) {
                  afterObj[key][childKey] = childOjb.low;
                }
              }
            }
          }
        }
      }
    }

    state.chatMessage = afterObj;
  },
  GET_ORDER_SKUIDS: (state,data) => {
    state.skus = data;
    //在页面刷新时将vuex里的信息保存到localStorage里
    localStorage.setItem("userMsg",JSON.stringify(state));
  },
  SET_LOCALPUBLICKEY: (state,data) => {
    state.localPublicKey = data;
  },
  SET_WEBIMERRORCODE: (state,codeNum) => {
    state.webImErrorCode = codeNum;
  },
  GTE_GOODSIDS: (state,data) => {
    state.goodsIds = data;
  //   localStorage.setItem("goodsIds",JSON.stringify(state));
  },
  GET_START_UP: (state,data) => {
    state.startup = data;
  },
  SET_LOGINPOPSHOWSTATUS: (state,data) => {
    state.loginPopShowStatus = data;
  }
}

const actions = {
  setLoginPopShowStatus: function({commit},data) {
    commit('SET_LOGINPOPSHOWSTATUS',data);
  },
  reqUpdateUserInfo: function({commit},data) {
    httpRequest.getUserInfo()
      .then(res => {
        console.log("---------------actions------获取的用户信息------");
        console.log(res);
        if (res.code == 200) {
          let userObj = res.data;
          let userInfo = {
            showname: userObj.showname,
            avatar: userObj.avatar.o,
            birthday: userObj.birthday,
            gender: userObj.gender,
            province: userObj.province,
            city: userObj.city,
            county: userObj.county,
            wallet: userObj.wallet,
            easemob_user: userObj.easemob_user,
            email: userObj.email,
            phone: userObj.phone,
            has_password: userObj.has_password,
            has_pay_password: userObj.has_pay_password
          };

          commit('GET_USER',userInfo);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  recordCourseFootprint({commit},data,callback) {
    if (!state.token) {
      return;
    }

    let recordData = data;
    console.log("----------记录足迹---" + JSON.stringify(recordData));
    httpRequest.recordCourseFootprint(recordData)
      .then(function(ret) {
        console.log("---------进入ret------" + JSON.stringify(ret));
        callback && callback(ret);
      }).catch(function(err) {
        callback && callback(err);
        console.log("---------进入err------" + JSON.stringify(err));
      })
  },
  setlocalEncryptPublicKey: function({commit},data) {
    if (!state.token) {
      return;
    }

    httpRequest.getCipherPublicKey()
      .then(function(ret) {
        if (ret.code == 200) {
          var curData = ret.data;
          setLocalPublicKey(curData);
        }
      }).catch(function(err) {

      })
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})




// WEBPACK FOOTER //
// ./src/store/index.js